import angular from 'angular';

import NetSalesGameListComponent from './net-sales-game-list-component';

export default angular
  .module('net-sales-game-list', [])
  .component('netSalesGameList', NetSalesGameListComponent);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/components/net-sales-game-list/net-sales-game-list-module.js